import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import BatchProcessingContainer from '../../components/chat/BatchProcessingContainer';
// ToastProvider는 글로벌(App.js)에서 제공
import { useSubscription } from '../../contexts/SubscriptionContext';
import ProUpgradeModal from '../../components/chat/ProUpgradeModal';
import { useAuth } from '../../contexts/AuthContext';
import { ClassFlowDemo } from '../../components/demo';
import './BatchSaenggibuPage.css';

const BatchSaenggibuPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth() || {};
  const { subscriptionStatus } = useSubscription();
  const isProUser = subscriptionStatus?.isPro || false;
  
  const [currentStep, setCurrentStep] = useState(1);
  const [batchData, setBatchData] = useState(null);
  const [selectedModel] = useState(isProUser ? 'gemini-2.5-flash' : 'gemini-2.5-flash-lite');
  const [showProModal, setShowProModal] = useState(false);

  const handleBack = () => {
    if (currentStep === 1) {
      // 첫 단계에서 뒤로가기 시 채팅 페이지로 이동
      navigate('/chat');
    } else {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <>
      <Helmet>
        <title>일괄 생기부 생성 | 2026 기재요령 완벽 적용 | 왓퀴즈</title>
        <meta 
          name="description" 
          content="파일 하나로 여러 학생의 생기부를 한번에 생성하세요. AI가 2026년 기재요령을 완벽히 적용하여 행동발달, 세특, 창체를 자동으로 작성합니다." 
        />
        <meta 
          name="keywords" 
          content="생기부 일괄 생성, 엑셀 생기부, 나이스 생기부, 생기부 자동 생성, AI 생기부, 2026 기재요령, 행동발달, 세특, 창체, 학생부 작성" 
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="일괄 생기부 생성 | 왓퀴즈" />
        <meta 
          property="og:description" 
          content="파일 하나로 여러 학생의 생기부를 한번에 생성하세요. 2026년 기재요령 완벽 적용." 
        />
      </Helmet>

      <div className="batch-saenggibu-page">
        <div className="batch-saenggibu-page-header">
          <button 
            className="batch-saenggibu-page-back-btn"
            onClick={() => navigate('/chat')}
            aria-label="채팅으로 돌아가기"
          >
            ← 홈으로
          </button>
          <div className="batch-saenggibu-page-title-section">
            <h1 className="batch-saenggibu-page-title">여러 학생 생기부 한번에 만들기</h1>
            <p className="batch-saenggibu-page-subtitle">
              선생님이 쓰던 학생별 기록 파일을 그대로 올리면 AI가 정리해요
            </p>
          </div>
        </div>

        {!currentUser && currentStep === 1 && (
          <div className="batch-saenggibu-page-demo">
            <ClassFlowDemo surface="batch_saenggibu" title="반 전체 생기부" />
          </div>
        )}

        <div className="batch-saenggibu-page-content">
          <BatchProcessingContainer
            onBack={handleBack}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            batchData={batchData}
            setBatchData={setBatchData}
            selectedModel={selectedModel}              // 🆕 모델 정보 전달
            isProUser={isProUser}                      // 🆕 PRO 사용자 여부 전달
            onShowProModal={() => setShowProModal(true)}  // 🆕 PRO 모달 콜백 전달
          />
        </div>
        
        {/* PRO 업그레이드 모달 */}
        {showProModal && (
          <ProUpgradeModal
            isOpen={showProModal}
            onClose={() => setShowProModal(false)}
            feature="고급 모드 생기부 생성"
          />
        )}
      </div>
    </>
  );
};

export default BatchSaenggibuPage;

